import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Container,
  Paper,
  Button
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReactComponent as CinchLogo } from '../cinch.svg';
import MemberHeader from '../components/MemberHeader';
import WelcomeSection from '../components/WelcomeSection';
import { useMember } from '../contexts/MemberContext';
import { useAuth } from '../contexts/AuthContext';

/**
 * Member Confirmation Page
 * Shows confirmation message and flashing banner after a member selects an offer.
 */
const MemberConfirmationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { primaryColor, secondaryColor } = useAuth();
  const { orientation } = useMember();
  const [bannerColor, setBannerColor] = useState(primaryColor || '#1976d2');

  // Flashing banner effect
  useEffect(() => {
    const interval = setInterval(() => {
      setBannerColor(prevColor =>
        prevColor === (primaryColor || '#1976d2')
          ? (secondaryColor || '#dc004e')
          : (primaryColor || '#1976d2')
      );
    }, 800); // Toggle color every 800ms

    return () => clearInterval(interval);
  }, [primaryColor, secondaryColor]);

  useEffect(() => {
    if (orientation === -1) {
      // the device was flipped over so navigate to the points earned page
      navigate('/cashier-login');
      //  state: {
      //    // COUPON SELECTED
      //  }
      //});
    }
  }, [orientation, location.state]);


  return (
    <Container sx={{
      width: '100% !important',
      maxWidth: '1024px !important',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
      px: '0 !important',
      py: 4
    }}>
      {/* Navigation header */}
      <MemberHeader />

      {/* Welcome section */}
      <WelcomeSection />

      {/* Main content area */}
      <Box flexGrow={1} display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        {/* Flashing banner */}
        <Paper
          elevation={3}
          sx={{
            width: '100vw',
            height: '300px',
            p: 4,
            my: 4,
            backgroundColor: bannerColor,
            color: 'white',
            transition: 'background-color 0.4s ease',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Typography
            variant="h4"
            align="center"
            fontWeight="bold"
            sx={{ mb: 2 }}
          >
            Ready
          </Typography>
          <Typography
            variant="h5"
            align="center"
          >
            When ready, please flip the tablet toward the cashier
          </Typography>
        </Paper>
      </Box>

      {/* Footer */}
      <Box pb={2} display="flex" justifyContent="center" alignItems="center">
        <Typography variant="body3" color="text.secondary">
          powered by
        </Typography>
        <Box ml={1} display="flex" alignItems="center">
          <CinchLogo
            width={75}
            style={{ marginRight: '4px' }}
          />
        </Box>
      </Box>
    </Container>
  );
};

export default MemberConfirmationPage;